module.exports = __webpack_public_path__ + "img/ribbon.f41d04b6.png";